import { defineComponent as _defineComponent } from 'vue'
import TileGridSection from './TileGridSection.vue';
import { computed } from 'vue';
import { TileGridWidgetResource, TileGridWidgetSection } from 'JS/dxp/types/widgets/tile-grid-widget';


export default /*#__PURE__*/_defineComponent({
  __name: 'TileGridWidget',
  props: {
    widget: null
  },
  setup(__props: any) {

const props = __props as {
	widget: TileGridWidgetResource;
}



// We need to include the tile index in the data-creative-name attribute for GA. Because tiles are split up into many
// arrays, we can't just use the index of the tile within the section. Other wise each section would have their own index 0, 1...
// This computes the starting index for each section AS IF the tiles were part of a single array. Then, when the section renders
// the attribute, it can add the value associated with itself to the index of the tile to get the "global" tile index.
const sectionStartingTileIndices = computed(() => props.widget.widget.sections.reduce((startingIndices, section, i, sections) => {
	if (i === 0) {
		return startingIndices.set(section, 0);
	}

	const previousSection = sections[i - 1];
	const previousSectionStartingIndex = startingIndices.get(previousSection);
	const previousSectionLength = previousSection?.tiles.length ?? 0;

	return startingIndices.set(section, previousSectionStartingIndex + previousSectionLength);
}, new Map<TileGridWidgetSection, number>()));



return { __sfc: true,props, sectionStartingTileIndices, TileGridSection }
}

})